module.exports = __webpack_public_path__ + "static/media/party-hat.53a1a5d6.gif";